import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";
export const ADD_NOTIFICATION_ACTION = createAsyncThunk('/notification/add', async (formData) => {
  try {
    const response = await AxiosInstance.post(APILIST.ADD_NOTIFICATION, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const GET_NOTIFICATION_ACTION = createAsyncThunk('/notification/get', async () => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_NOTIFICATION, {
      params: {
        request_type: 2
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const GET_NOTIFICATION_LANGUAGE_REQUEST_ACTION = createAsyncThunk('/new-notification/get', async () => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_NOTIFICATION, {
      params: {
        request_type: 2,
        type: 8
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const ADD_UPDATE_NOTIFICATION_FCM_ACTION = createAsyncThunk('/add-update-fcm-token/post', async (formData) => {
  try {
    const response = await AxiosInstance.post(APILIST.ADD_UPDATE_FCM_TOKEN, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const ADD_UPDATE_NOTIFICATION_UNREAD_ACTION = createAsyncThunk('/unread-notification/post', async (id) => {
  try {
    const formData = new FormData();
    formData.append("notification_id", id);
    const userId = localStorage.getItem("Interpreto");
    formData.append("user_id", JSON.parse(userId)?.id);
    formData.append("request_type", 2);
    const response = await AxiosInstance.post(APILIST.NOTIFICATION_UNREAD_COUNT, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const GET_NOTIFICATION_UNREAD_COUNT_ACTION = createAsyncThunk('/notification-unread-round/get', async (id) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_NOTIFICATION_UNREAD_COUNT_API, {
      params:{
        user_id:id,
        type:"8,9"
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
